<template>
  <div id="contactusForm">
  <b-modal id="my-modal" v-model="modalShow" >Your Request has been submitted successfully.</b-modal>
    <b-card no-body border-variant="light" class="form-card rounded">
      <b-container fluid>
        <b-row no-gutters class="form">
          <b-col>
            <b-form @submit.prevent="showOkModal()">
              <b-form-group id="input-group-2">
                <b-row>
                  <b-col cols="12" class="head">
                    <p>Submit your Request</p>
                  </b-col>
                </b-row>
                <b-form-input id="input-name" v-model="form.name" required placeholder="Name*"></b-form-input>
              </b-form-group>
              <b-form-group id="input-group-2">
                <b-row>
                  <b-col>
                    <b-input
                      id="inline-form-input-email"
                      class="mb-2 mr-sm-2 mb-sm-0"
                      placeholder="Email*"
                      v-model="form.email"
                      type="email"
                       required
                       oninput="setCustomValidity('')"
                      oninvalid="this.setCustomValidity('Please Enter valid email')"
                    ></b-input>
                  </b-col>
                  <b-col>
                    <b-input
                      id="inline-form-input-mobile"
                      class="mb-2 mr-sm-2 mb-sm-0"
                      type="tel"
                      placeholder="Mobile Number*"
                      v-model="form.number"
                      @keypress="isNumber(event)"
                      oninput="setCustomValidity('')"
                      required
                      ref="mobilefield"
                    ></b-input>
                  </b-col>
                </b-row>
              </b-form-group>
              <b-form-group id="input-group-2">
                <b-form-textarea id="input-textarea" placeholder="Your Request*" v-model="form.request" required rows="3"></b-form-textarea>
              </b-form-group>
              <div id="contact-submit">
                <b-button type="submit" variant="danger" >Submit</b-button>
              </div>
            </b-form>
          </b-col>
        </b-row>
      </b-container>
    </b-card>
  </div>
</template>

<script>
export default {
  name: "ContactUs-Form",
  data() {
    return {
      form: {
        email: "",
        name: "",
        text: "",
        number:"",
        request:"",
        validated:false,
        mobileValidation:false,
        
      },
      modalShow: false,
    };
  },
  methods:{
    onSubmit(){
 
      this.modalShow=true;
      
    },
    submitForm() {
      console.log('submitted')
      this.modalShow=true;
      console.log(this.modalShow)
   
    },
    showOkModal() {
      var mobileRegex=/^[0]?[789]\d{9}$/;
      
      if (this.form.number.length<10 ||this.form.number.length>10 ){
        this.mobileValidation=false
        
      }
      else{
        if(this.form.number.match(mobileRegex))
         {
           this.mobileValidation=true
          
         }
         else{
           this.mobileValidation=false
         }
      }

      if(this.mobileValidation==false){
         this.validated=false
         var el = this.$refs.mobilefield;
         el.oninvalid = el.setCustomValidity('Please Enter a Valid Mobile Number');
      }
      else{
        this.validated=true
      }


      if(this.validated==true)
      {

        

        // var data={"fullName":this.form.name,"email":this.form.email,"mobile":this.form.number,"request":this.form.request};
        // //var arr["data"]= data;
        // var formData = {'data':data};
        // var json_string= JSON.stringify(formData);
        // var formData={"data":data};
        // formData['data']=data;
       
        // var json_string = JSON.stringify(formData);
        // console.log(json_string)
           this.actionOk = ''
      
    //      this.$axios.post(process.env.VUE_APP_SUBMIT_FORM_API_URL, {
    //       "fullName":this.form.name,"email":this.form.email,"mobile":this.form.number,"request":this.form.request
           
    //      }, // the data to post
    // { headers: {
    //   'Content-type': 'application/x-www-form-urlencoded;charset=UTF-8',
    //   }
    // })
    this.$axios({
      method: 'post',
      url:process.env.VUE_APP_SUBMIT_FORM_API_URL,
       data: { 
         data:{"fullName":this.form.name,"email":this.form.email,"mobile":this.form.number,"request":this.form.request,}
       }
    })
    .then(response => {
      
        if(response.data.status==1){
         
          this.$bvModal.msgBoxOk('Your Request has been submitted successfully.', {
                    title: 'Confirmation',
                    size: 'sm',
                    buttonSize: 'sm',
                    okVariant: 'success',
                    headerClass: 'p-2 border-bottom-0',
                    footerClass: 'p-2 border-top-0',
                    centered: true
                  })
        }
        else{
          this.$bvModal.msgBoxOk('Request Submission Failed. Please try again...', {
                    title: 'Failed',
                    size: 'sm',
                    buttonSize: 'sm',
                    okVariant: 'danger',
                    headerClass: 'p-2 border-bottom-0',
                    footerClass: 'p-2 border-top-0',
                    centered: true
                  })

        }
      
        
    });
      // this.$bvModal.msgBoxOk(this.form.name+', Your Request has been submitted successfully.', {
      //               title: 'Confirmation',
      //               size: 'sm',
      //               buttonSize: 'sm',
      //               okVariant: 'success',
      //               headerClass: 'p-2 border-bottom-0',
      //               footerClass: 'p-2 border-top-0',
      //               centered: true
      //             })

         this.form.name='',
            this.form.email='',
            this.form.number='',
            this.form.request=''

      }
      //  this.actionOk = ''
    //      this.$axios.post('http://localhost/websiteApi/submitRequest.php', {
    //       name:this.form.name,
    //       email:this.form.email,
    //       number:this.form.number,
    //       request:this.form.request


    //      }, // the data to post
    // { headers: {
    //   'Content-type': 'application/x-www-form-urlencoded',
    //   }
    // }).then(response => {
        // this.$bvModal.msgBoxOk('Dear '+this.form.name+', Your Request has been submitted successfully.', {
        //   title: 'Confirmation',
        //   size: 'sm',
        //   buttonSize: 'sm',
        //   okVariant: 'success',
        //   headerClass: 'p-2 border-bottom-0',
        //   footerClass: 'p-2 border-top-0',
        //   centered: true
        // })
        //   // .then(value => {
        //     // this.actionOk = value,
            // this.form.name='',
            // this.form.email='',
            // this.form.number='',
            // this.form.request=''
           
          // })

          //  });
          
    },
    isNumber: function(evt) {
      evt = (evt) ? evt : window.event;
      var charCode = (evt.which) ? evt.which : evt.keyCode;
      if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46) {
        evt.preventDefault();
      } else {
        if(this.form.number.length<10)
        {
              return true;
        }
        else{
            evt.preventDefault();
        }
       

      }
    },

    

  }
};
</script>
<style scoped>
.form-card {
  border-radius: 30px !important;
  /*box-shadow: 0 0 8px #d0d0d0; */
  box-shadow: 0 0 2px 0 rgba(0, 0, 0, 0.4);
  padding: 1rem;
  background: white;
  width: 100%;
}
.btn-danger {
  background-color: var(--mainRedColor);
  box-shadow: 0 0 2px 0 rgba(0, 0, 0, 0.4);
}

.btn-danger:hover {
    color: #fff;
    background-color: #c82333;
    border-color: #bd2130;
    box-shadow: 0px 0px 2px rgba(208, 208, 208, 0.4);
}
.head {
  font-size: 30px;
  color: var(--mainBlueColor);
  padding-left: 1rem;
  font-weight: bold;
}

#input-textarea,
#input-name,
#inline-form-input-email,
#inline-form-input-mobile {
  background: #eeeeee;
  width: 100%;
}
#input-name::placeholder,
#inline-form-input-email::placeholder,
#inline-form-input-mobile::placeholder,
#input-textarea::placeholder {
  color: var(--mainBlueColor);
  font-weight: 600;
}
#contact-submit {
  text-align: right;
  padding-top: 1.5rem;
  width: 25%;
  float: right;
}
.form {
  height: 100%;
  padding-top: 1rem;
  padding-bottom: 1rem;
}

/* Tablet Screens */
@media (min-width: 768px) and (max-width: 1024px) and (orientation: portrait) {
  #input-name::placeholder,
  #inline-form-input-email::placeholder,
  #inline-form-input-mobile::placeholder,
  #input-textarea::placeholder {
    color: var(--mainBlueColor);
    font-weight: 500;
    font-size: 0.75rem;
  }
  #contact-submit {
    text-align: center;
    width: 100%;
  }

  .form-card {
    border-radius: 30px !important;
    box-shadow: 0 0 8px #d0d0d0;
    padding: 1rem;
    background: white;
    width: 75%;
    margin: 0 auto;
  }
}
/* Mobile Screens */
@media (min-width: 481px) and (max-width: 767px) {
  #input-name::placeholder,
  #inline-form-input-email::placeholder,
  #inline-form-input-mobile::placeholder,
  #input-textarea::placeholder {
    color: var(--mainBlueColor);
    font-weight: 500;
    font-size: 0.75rem;
  }
  #contact-submit {
    text-align: center;
     width: 100%;
    text-align:center;
    float:none;
  }
}
@media (max-width: 480px) {
  .head {
    font-size: 1.4rem;
  }
  #inline-form-input-email,
  #inline-form-input-mobile,
  #input-name,
  #input-textarea {
    font-size: 0.74rem;
  }
  #contact-submit {
    padding-top: 0;
    width: 100%;
    text-align:center;
    float:none;
  }
  .form {
    height: 100%;
    padding-top: 0.3rem;
    padding-bottom: 0.3rem;
  }
 
}
</style>
